import React, { useState } from "react";
import { Collapse } from "reactstrap";

import { useTranslation } from "react-i18next";

import DateTime from "luxon/src/datetime.js";

import "./ExtraInfo.scss";

const ExtraInfo = ({ obj, title }) => {
  const { t } = useTranslation();

  const [collapseExtraInfo, setCollapseExtraInfo] = useState(false);
  const [collapseSubExtraInfo, setCollapseSubExtraInfo] = useState({});

  const toggleExtraInfo = () => {
    setCollapseExtraInfo((prev) => !prev);
  };

  const toggleSubExtraInfo = (key) => {
    setCollapseSubExtraInfo((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const checkValueType = (value) => {
    let type = null;
    if (value) {
      switch (Object.prototype.toString.call(value)) {
        case "[object Boolean]":
          type = "boolean";
          break;
        case "[object Number]":
          type = "number";
          break;
        case "[object String]":
          if (
            /(\d{4})-|(\d{2})-(\d{2})/.test(value) &&
            !isNaN(Date.parse(value))
          ) {
            type = "date";
          } else {
            type = "string";
          }
          break;
        case "[object Date]":
          type = "date";
          break;
        case "[object Array]":
          type = "array";
          break;
        case "[object Object]":
          type = "object";
          break;
        default:
          type = null;
          break;
      }
    }
    return type;
  };

  const renderBoolStringNum = (idx, key, value) => (
    <div className="d-flex justify-content-between mb-3" key={idx}>
      <div className="d-flex font-weight-bold pr-3 escapeDragScroll">{t(key)}:</div>
      <div className="d-flex text-break text-left escapeDragScroll">{t(value)}</div>
    </div>
  );

  const renderDate = (idx, key, value) => (
    <div className="d-flex justify-content-between mb-3" key={idx}>
      <div className="d-flex font-weight-bold pr-3 escapeDragScroll">{t(key)}:</div>
      <div className="d-flex text-break text-left escapeDragScroll">
        {DateTime.fromJSDate(new Date(value))
          .setLocale(localStorage.getItem("i18nextLng"))
          .toFormat("D")}
      </div>
    </div>
  );

  const renderArray = (idx, key, value) => (
    <div className="justify-content-between mb-3" key={idx}>
      <div
        className="d-flex extra-info-sub-item pointer mb-3 py-0 pl-0"
        onClick={() => {
          toggleSubExtraInfo(key);
        }}
      >
        <div className="pr-2">
          <i
            className={`bx bx bxs-chevron-right color2 font-size-15 item ${
              collapseSubExtraInfo[key] ? "opened" : "closed"
            }`}
          />
        </div>
        <div>
          <div className="font-weight-bold escapeDragScroll">{t(key)}:</div>
        </div>
      </div>
      <Collapse
        isOpen={collapseSubExtraInfo[key]}
        className="pt-3 px-3 mx-1 my-0 extra-info-obj-card border"
      >
        {value.map((element, key) => (
          <div key={key} className="d-flex mb-3">
            <div>
              <i className="mdi mdi-circle-medium font-size-10 pr-2" />
            </div>
            <div className="overflow-auto">
              {checkValueType(element) === "object"
                ? showExtraInfo(element)
                : t(element)}
            </div>
          </div>
        ))}
      </Collapse>
    </div>
  );

  const renderObject = (idx, key, value) => (
    <div className="justify-content-between mb-3" key={idx}>
      <div className="font-weight-bold mb-3 ">{t(key)}:</div>
      <div className="px-3 pt-3 extra-info-obj-card border">
        {showExtraInfo(value)}
      </div>
    </div>
  );

  const renderExtraInfo = (idx, key, value, type) => {
    let renderInfo = null;
    if (type) {
      switch (type) {
        case "boolean":
        case "string":
        case "number":
          renderInfo = renderBoolStringNum(idx, key, value);
          break;
        case "date":
          renderInfo = renderDate(idx, key, value);
          break;
        case "array":
          renderInfo = renderArray(idx, key, value);
          break;
        case "object":
          renderInfo = renderObject(idx, key, value);
          break;
        default:
          renderInfo = null;
          break;
      }
    }
    return renderInfo;
  };

  const showExtraInfo = (obj) => {
    let render = [];
    obj &&
      Object.entries(obj).forEach((element, idx) => {
        const valueType = checkValueType(element[1]);
        render.push(renderExtraInfo(idx, element[0], element[1], valueType));
      });
    return render;
  };

  return (
    <div
      key={title}
      className={`item subitem ${collapseExtraInfo && "item-opened-child"}`}
    >
      <div
        className="text-wrap pointer d-flex py-3"
        onClick={() => {
          toggleExtraInfo();
        }}
      >
        <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon-child"></i>
        <div className="d-flex flex-column w-100 ml-2 pl-1">
          <div className="d-flex justify-content-between my-auto">
            <div className="d-inline-flex order-1 title font-weight-bold">
              {t(title)}
            </div>
          </div>
        </div>
      </div>
      <Collapse
        isOpen={collapseExtraInfo}
        className="pt-3 px-3 mx-1 my-0 border"
      >
        {obj && Object.keys(obj).length > 0 ? (
          showExtraInfo(obj)
        ) : (
          <div className="text-center mb-3">
            {t("No matching records found")}
          </div>
        )}
      </Collapse>
    </div>
  );
};

export default ExtraInfo;
